export default __webpack_public_path__ + "static/media/6.c73c70ac.jpg";